import { IWizardStep, IWizardStepsGroup } from '../models/IWizardStep'

import { getAllWizardSteps } from './getAllWizardSteps'

export const findNextWizardStep = (
  data: (IWizardStep | IWizardStepsGroup)[],
  activeStepId: string
) => {
  const allSteps = getAllWizardSteps(data)
  const currentStepIndex = allSteps.findIndex((step) => step.id === activeStepId)

  return currentStepIndex < allSteps.length - 1 ? allSteps[currentStepIndex + 1].id : null
}
